"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCustomerAccountError = void 0;
const pushToDataLayer_1 = require("./pushToDataLayer");
function trackCustomerAccountError(eventLabel) {
    (0, pushToDataLayer_1.pushToDataLayer)({
        event: 'JS_Event',
        eventCategory: 'CustomerAccount',
        eventAction: 'Error',
        eventLabel,
        nonInteraction: true,
    });
}
exports.trackCustomerAccountError = trackCustomerAccountError;
//# sourceMappingURL=trackCustomerAccountError.js.map